import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './HowItWorks.css';

const HowItWorks: React.FC = () => {
  const { t } = useLanguage();
  return (
    <section id="how-it-works" className="how-it-works section">
      <div className="container">
        <h2 className="section-title">{t('howItWorks.title')}</h2>
        <p className="section-subtitle">
          {t('howItWorks.subtitle')}
        </p>
        
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3 className="step-title">{t('howItWorks.steps.contact.title')}</h3>
              <p className="step-description">
                {t('howItWorks.steps.contact.description')}
              </p>
            </div>
          </div>
          
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3 className="step-title">{t('howItWorks.steps.offer.title')}</h3>
              <p className="step-description">
                {t('howItWorks.steps.offer.description')}
              </p>
            </div>
          </div>
          
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3 className="step-title">{t('howItWorks.steps.pickup.title')}</h3>
              <p className="step-description">
                {t('howItWorks.steps.pickup.description')}
              </p>
            </div>
          </div>
          
          <div className="step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3 className="step-title">{t('howItWorks.steps.payment.title')}</h3>
              <p className="step-description">
                {t('howItWorks.steps.payment.description')}
              </p>
            </div>
          </div>
        </div>
        
        <div className="car-photos">
          <div className="photo-container">
            <img src="/photos-split2.png" alt="Car parts processing" className="car-photo" />
          </div>
        </div>
        
        <div className="cta-section">
          <h3 className="cta-title">{t('howItWorks.cta.title')}</h3>
          <p className="cta-subtitle">
            {t('howItWorks.cta.subtitle')}
          </p>
          
          <div className="car-photos">
            <div className="photo-container">
              <img src="/photos-split12.png" alt="Car parts collection" className="car-photo" />
            </div>
          </div>
          
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="btn"
          >
            {t('howItWorks.cta.button')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
